import React from 'react';
import { ProgressiveProfileSetup } from './EnhancedOnboardingComponents';
import { NotificationProvider } from './SmartNotificationComponents';

const ProfileSetupDemo = () => {
  const handleComplete = (profileData) => {
    console.log('Profile completed:', profileData);
    alert('Profile setup complete! Timer aesthetic has been improved.');
  };

  return (
    <NotificationProvider>
      <div className="min-h-screen">
        <ProgressiveProfileSetup 
          onComplete={handleComplete}
        />
      </div>
    </NotificationProvider>
  );
};

export default ProfileSetupDemo;